import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.fundbook-container > :global(.page-navigation > nav) {
    top: 94px;
    background-color: #ffffff;
}
.link {
    color: #24c0d8;
    font-weight: normal;
    touch-action: manipulation;
    cursor: pointer;
}
.link:hover {
    color: #086ea1;
    text-decoration: underline;
}
.dash {
    width: 40px;
    height: 3px;
    background-color: #bbbbbb;
    margin: calc(24px / 2) auto;
}
.error-container {
    margin-top: 100px;
    text-align: center;
    margin-bottom: 200px;
}
.error-header {
    margin-top: calc(24px / 2);
    font-family: 'Nimbus Sans Condensed', 'Nimbus Sans Light',
        'Nimbus Sans Con', sans-serif;
    font-size: 36px;
}
.retry-msg {
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-size: 14px;
    font-style: italic;
    color: #787778;
}
`;

export default styles;